import React from 'react';
import { useNavigate } from "react-router-dom";
import { useData } from '../../context/DataContext';
import Loading from '../Loading/Loading';
import Cookies from 'js-cookie';
import './Dashboard.css';

function StatCard({ icon, title, primaryValue, primaryLabel, secondaryLabel, secondaryValue, todayValue, viewLabel, onView, cardClass }) {
    return (
        <div className={`stat-card ${cardClass}`} onClick={onView}>
            <div className="stat-card-header">
                <span className="stat-card-title">{title}</span>
                <div className="stat-card-icon">
                    <i className={icon} />
                </div>
            </div>

            <span className="stat-primary-value">{primaryValue}</span>
            <span className="stat-primary-label">{primaryLabel}</span>

            <div className="stat-secondary">
                <span>{secondaryLabel}:</span>
                <span className="stat-secondary-value">{secondaryValue}</span>
                {todayValue !== undefined && (
                    <span className="stat-today-badge">
                        <i className="fa-solid fa-arrow-up" style={{ fontSize: '0.6rem' }} />
                        {todayValue} today
                    </span>
                )}
            </div>

            <div className="stat-card-footer">
                <button className="stat-view-btn">
                    {viewLabel}
                    <i className="fa-solid fa-arrow-right" />
                </button>
            </div>
        </div>
    );
}

function Dashboard() {
    const navigate = useNavigate();
    const user = JSON.parse(Cookies.get('artfroAdminUser') || '{}');
    const {
        userData, orderData, donationsData, subscribersData,
        todaySubscriptions, contactedData, productsData,
        loading, error, todayRegistrations, totalDonationsAmount, todayContacted
    } = useData();

    if (loading) return <Loading />;
    if (error) return <p style={{ color: 'var(--error)', padding: 24 }}>Error: {error}</p>;

    const greetingHour = new Date().getHours();
    const greeting = greetingHour < 12 ? 'Good morning' : greetingHour < 17 ? 'Good afternoon' : 'Good evening';
    const todayStr  = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

    const stats = [
        {
            cardClass: 'card-users',
            icon: 'fa-regular fa-user',
            title: 'Registered Users',
            primaryValue: userData.length,
            primaryLabel: 'total users',
            secondaryLabel: 'Today',
            secondaryValue: todayRegistrations.length,
            todayValue: todayRegistrations.length,
            viewLabel: 'View users',
            onView: () => navigate('/registered-users'),
        },
        {
            cardClass: 'card-orders',
            icon: 'fa-solid fa-bag-shopping',
            title: 'Orders',
            primaryValue: orderData.length,
            primaryLabel: 'total orders',
            secondaryLabel: 'Total',
            secondaryValue: orderData.length,
            viewLabel: 'View orders',
            onView: () => navigate('/orders'),
        },
        {
            cardClass: 'card-donations',
            icon: 'fa-solid fa-hand-holding-dollar',
            title: 'Donations',
            primaryValue: donationsData.length,
            primaryLabel: 'total donors',
            secondaryLabel: 'Raised',
            secondaryValue: `$${totalDonationsAmount}`,
            viewLabel: 'View donations',
            onView: () => navigate('/donations'),
        },
        {
            cardClass: 'card-subs',
            icon: 'fa-solid fa-bell',
            title: 'Subscriptions',
            primaryValue: subscribersData.length,
            primaryLabel: 'subscribers',
            secondaryLabel: 'Today',
            secondaryValue: todaySubscriptions.length,
            todayValue: todaySubscriptions.length,
            viewLabel: 'View subscribers',
            onView: () => navigate('/subscriptions'),
        },
        {
            cardClass: 'card-support',
            icon: 'fa-solid fa-headset',
            title: 'Contact Support',
            primaryValue: contactedData.length,
            primaryLabel: 'total tickets',
            secondaryLabel: 'Today',
            secondaryValue: todayContacted.length,
            todayValue: todayContacted.length,
            viewLabel: 'View tickets',
            onView: () => navigate('/contact-support'),
        },
        {
            cardClass: 'card-products',
            icon: 'fa-solid fa-box-open',
            title: 'Products',
            primaryValue: productsData.length,
            primaryLabel: 'in catalog',
            secondaryLabel: 'Active',
            secondaryValue: productsData.length,
            viewLabel: 'View products',
            onView: () => navigate('/products'),
        },
    ];

    return (
        <div>
            {/* Welcome banner */}
            <div className="dashboard-welcome">
                <div className="dashboard-welcome-text">
                    <div className="dashboard-welcome-greeting">
                        {greeting}, <span>{user.name || 'Admin'}</span>
                    </div>
                    <p className="dashboard-welcome-sub">Here's an overview of your platform today.</p>
                </div>
                <div className="dashboard-welcome-badge">
                    <i className="fa-regular fa-calendar" />
                    {todayStr}
                </div>
            </div>

            {/* Stats */}
            <div className="dashboard-grid">
                {stats.map((stat) => (
                    <StatCard key={stat.title} {...stat} />
                ))}
            </div>
        </div>
    );
}

export default Dashboard;
